import { render, staticRenderFns } from "./TableFE.vue?vue&type=template&id=b96abcb4&"
import script from "./TableFE.vue?vue&type=script&lang=js&"
export * from "./TableFE.vue?vue&type=script&lang=js&"
import style0 from "./TableFE.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports